export default __webpack_public_path__ + "static/media/products-1.0302b807.webp";